export function googleDataToEntities(data: any) {
  try {
    return data?.map((i: any) => {
      const pos = i?.GeoObject?.Point?.pos;
      const [lng, lat] = pos.split(' ').map(Number);
      return {
        address: `${i?.GeoObject?.description}${
          i?.GeoObject?.name ? `, ${i?.GeoObject?.name}` : ''
        }`,
        lng,
        lat,
      };
    });
  } catch (e) {
    return [];
  }
}
